module.exports = __webpack_public_path__ + "static/scale-model-of-a-bronx-tale-street-in-yonkers-new-york-5c69e1b340edecbbcdb95c0d071995e0.png";